jQuery(document).ready(function($){
  var customizeCROObserver = null;
  var customizeCartDrawerObserver = null;

  function alThemeString(key, fallback) {
    return window.theme && theme.strings && theme.strings[key] ? theme.strings[key] : fallback;
  }

  function alThemeTemplate(key, fallback, replacements) {
    var value = alThemeString(key, fallback);
    Object.keys(replacements || {}).forEach(function (name) {
      value = value.split('[' + name + ']').join(replacements[name]);
    });
    return value;
  }

  function alNormalizePrice(value) {
    if (value === undefined || value === null || value === '') {
      return '';
    }

    var number = parseFloat(String(value).replace(',', '.'));

    if (isNaN(number)) {
      return String(value);
    }

    return number.toFixed(2);
  }

  function alFormatPrice(value) {
    var normalized = alNormalizePrice(String(value).replace('CHF', '').replace(/[^0-9.,-]/g, ''));

    if (!normalized) {
      return '';
    }

    var number = parseFloat(normalized);

    if (isNaN(number)) {
      return String(value);
    }

    if (Math.round(number * 100) % 100 === 0) {
      return 'CHF ' + Math.round(number);
    }

    return 'CHF ' + number.toFixed(2);
  }

  function alPriceNumber(value) {
    if (value === undefined || value === null || value === '') {
      return 0;
    }

    var cleaned = String(value)
      .replace('CHF', '')
      .replace(/'/g, '')
      .replace(/\s/g, '')
      .replace('.-', '.00')
      .replace(/[^0-9.,-]/g, '')
      .replace(',', '.');
    var number = parseFloat(cleaned);

    return isNaN(number) ? 0 : number;
  }

  function alGetCustomizeGrid() {
    var $grid = $('.customize-base-grid:visible').first();

    if (!$grid.length) {
      $grid = $('.customize-base-grid').first();
    }

    return $grid;
  }

  function alGetCustomizePriceElement($grid) {
    var $price = $();

    if ($grid && $grid.length) {
      $price = $grid.nextAll('.customize-product-price-grid').first().find('.customize_product_price');
    }

    if (!$price.length) {
      $price = $('.customize-product-price-grid:visible .customize_product_price').first();
    }

    if (!$price.length) {
      $price = $('.customize-product-price-grid .customize_product_price').last();
    }

    return $price;
  }

  function alFindAddonInput($item) {
    var variantId = $item.attr('data-id');
    var handle = $.trim(($item.attr('class') || '').split(/\s+/)[0] || '');

    return alGetCustomizeGrid().find('.customize-addon-variants input').filter(function () {
      var $input = $(this);

      return (variantId && $input.val() === variantId) || (handle && $input.attr('data-handle') === handle);
    }).first();
  }

  function alAddonUnitPrice($item) {
    var defaultPrice = $item.attr('data-default-price');

    if (defaultPrice !== undefined && defaultPrice !== null && defaultPrice !== '') {
      return alPriceNumber(defaultPrice);
    }

    var $input = alFindAddonInput($item);
    var inputPrice = $input.attr('data-price');
    var unitPrice = alPriceNumber(inputPrice);

    if (inputPrice !== undefined && inputPrice !== null && inputPrice !== '') {
      $item.attr('data-default-price', unitPrice.toFixed(2));
    }

    return unitPrice;
  }

  function alCalculateCustomizePrice() {
    var $grid = alGetCustomizeGrid();
    var $price = alGetCustomizePriceElement($grid);
    var basePrice = alPriceNumber($price.attr('data-base-price') || $grid.attr('data-base-price'));
    var freeRemaining = parseInt($grid.attr('data-freeaddon'), 10);
    var includedAddon = 0;
    var addonTotal = 0;
    var selectedQty = 0;

    if (isNaN(freeRemaining) || freeRemaining < 0) {
      freeRemaining = 0;
    }

    includedAddon = freeRemaining;

    $grid.find('.selected_stone li').each(function () {
      var $item = $(this);
      var qty = parseInt($item.attr('data-qty'), 10) || parseInt($item.find('.quan_').text(), 10) || 0;
      var unitPrice = alAddonUnitPrice($item);
      var freeQty = 0;
      var payableQty = qty;

      if (qty <= 0) {
        return;
      }

      selectedQty += qty;

      if (freeRemaining > 0) {
        freeQty = Math.min(qty, freeRemaining);
        freeRemaining -= freeQty;
        payableQty = qty - freeQty;
      }

      addonTotal += payableQty * unitPrice;
    });

    var totalPrice = basePrice + addonTotal;
    var root = $grid.closest('[data-al-sale-percent]')[0];
    var displayCents = theme.alSaleAmount(Math.round(totalPrice * 100), root);

    return {
      addonTotal: addonTotal,
      basePrice: basePrice,
      formattedTotal: alFormatPrice(displayCents / 100),
      includedAddon: includedAddon,
      selectedQty: selectedQty,
      totalPrice: totalPrice
    };
  }

  function alApplyCustomizePriceState() {
    var priceState = alCalculateCustomizePrice();
    var $price = alGetCustomizePriceElement(alGetCustomizeGrid());

    if ($price.length) {
      $price
        .attr('data-new-price', priceState.totalPrice.toFixed(2))
        .text(priceState.formattedTotal);
      $('.customize-product-price-grid').show();
    }

    var root = alGetCustomizeGrid().closest('[data-al-sale-percent]')[0];
    var rawCents = Math.round(priceState.totalPrice * 100);
    theme.alUpdateConfiguratorSale(root, rawCents, theme.alSaleAmount(rawCents, root));
    return priceState;
  }

  function alRefreshAddonAvailability() {
    $('.customize-base-grid .customize-base-inner .customize-box').each(function () {
      var $box = $(this);

      if ($box.hasClass('no-stone')) {
        return;
      }

      var $input = $box.find('.customize-addon-variants input').first();

      if (!$input.length) {
        return;
      }

      var availableRaw = $input.attr('data-quantity-available') || $input.attr('data-stock-quan') || $box.attr('data-quantity-available');
      var available = parseInt(availableRaw, 10);

      if (isNaN(available)) {
        return;
      }

      var isUnavailable = available <= 0;
      var $label = $box.find('.customize-addon-label').first();

      $box.toggleClass('not-available', isUnavailable);
      $input.prop('disabled', isUnavailable);
      $label.attr('aria-disabled', isUnavailable ? 'true' : 'false');
      $label.attr('title', isUnavailable ? alThemeString('alunirCustomizeUnavailable', 'Dieses Produkt ist derzeit nicht verf\u00FCgbar') : '');
    });
  }

  function alSelectedAddons() {
    var items = [];
    var totalQty = 0;

    alGetCustomizeGrid().find('.selected_stone li').each(function () {
      var $item = $(this);
      var name = $.trim($item.find('.name').text());
      var qty = parseInt($item.attr('data-qty'), 10) || parseInt($item.find('.quan_').text(), 10) || 1;

      if (name) {
        items.push(qty > 1 ? name + ' x' + qty : name);
      }

      totalQty += qty;
    });

    return {
      items: items,
      totalQty: totalQty
    };
  }

  function alScrollToCustomizeGrid() {
    var $target = alGetCustomizeGrid();

    if (!$target.length) {
      return;
    }

    var headerOffset = $('.site-header').outerHeight() || 0;
    var targetTop = Math.max($target.offset().top - headerOffset - 14, 0);

    $('html, body').animate({
      scrollTop: targetTop
    }, 420);
  }

  function alUpdateCustomizeCROState() {
    if (!$('.customize-base-grid').length) {
      return;
    }

    alRefreshAddonAvailability();

    var selection = alSelectedAddons();
    var hasSelection = selection.totalQty > 0;
    var pendantLabel = selection.totalQty === 1
      ? alThemeString('alunirCustomizePendantSingular', 'Anh\u00E4nger')
      : alThemeString('alunirCustomizePendantPlural', 'Anh\u00E4nger');
    var countText = hasSelection
      ? selection.totalQty + ' ' + pendantLabel
      : alThemeString('alunirCustomizeZeroPendants', '0 Anh\u00E4nger');
    var selectionText = hasSelection ? selection.items.join(', ') : alThemeString('alunirCustomizeNoPendantsSelected', 'Noch keine Anh\u00E4nger gew\u00E4hlt');
    var priceState = alApplyCustomizePriceState();
    var priceText = priceState.formattedTotal;
    var basePrice = priceState.basePrice;
    var addonPrice = '';

    $('.customize-base-grid .customize-box:not(.no-stone)').each(function () {
      var $box = $(this);

      if (addonPrice || $box.hasClass('not-available')) {
        return;
      }

      var price = $box.find('.customize-addon-variants input[data-price-not-zero], .customize-addon-variants input[data-price]').first().attr('data-price');

      if (price) {
        addonPrice = alNormalizePrice(price);
      }
    });

    $('[data-customize-summary]').toggleClass('has-selection', hasSelection);
    $('[data-customize-summary-items]').text(hasSelection ? '' : selectionText);
    $('[data-customize-sticky-count]').text(countText);
    $('[data-customize-sticky-selection]').text(hasSelection ? selectionText : alThemeString('alunirCustomizeChoosePendant', 'Anh\u00E4nger w\u00E4hlen'));
    $('[data-customize-sticky-price]').text(priceText || alFormatPrice(basePrice));

    if (basePrice && addonPrice) {
      var root = alGetCustomizeGrid().closest('[data-al-sale-percent]')[0];
      basePrice = theme.alSaleAmount(Math.round(basePrice * 100), root) / 100;
      addonPrice = theme.alSaleAmount(Math.round(parseFloat(addonPrice) * 100), root) / 100;
      var priceNote = alThemeTemplate('alunirCustomizeNecklacePriceNote', 'Kette [base] + [addon] pro Anh\u00E4nger', { base: alFormatPrice(basePrice), addon: alFormatPrice(addonPrice) });

      if (priceState.includedAddon > 0) {
        priceNote = alThemeTemplate('alunirCustomizeNecklaceIncludedNote', 'Kette [base] | [count] Anh\u00E4nger inklusive, danach [addon] pro Anh\u00E4nger', { base: alFormatPrice(basePrice), count: priceState.includedAddon, addon: alFormatPrice(addonPrice) });
      }

      $('[data-customize-price-note]').text(priceNote);
    }

    $('.al-customize-sticky').toggleClass('is-visible', true);
    $('body').toggleClass('al-customize-sticky-active', true);
    $('body').toggleClass(
      'al-customize-theme-preview',
      !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main')
    );
    $('[data-customize-sticky-add]')
      .prop('disabled', false)
      .toggleClass('is-secondary', !hasSelection)
      .text(hasSelection ? alThemeString('addToCart', 'In den Warenkorb') : alThemeString('alunirCustomizeChoosePendant', 'Anh\u00E4nger w\u00E4hlen'));
  }

  function alUpdateCartDrawerState() {
    $('body').toggleClass('al-cart-drawer-open', $('#CartDrawer').hasClass('drawer--is-open'));
  }

  function alInitCustomizeCRO() {
    if (!$('.customize-base-grid').length) {
      return;
    }

    if (!customizeCROObserver && window.MutationObserver) {
      var grid = document.querySelector('.customize-base-grid .customize-base-inner');

      if (grid) {
        customizeCROObserver = new MutationObserver(function () {
          window.requestAnimationFrame(alUpdateCustomizeCROState);
        });
        customizeCROObserver.observe(grid, {
          attributes: true,
          childList: true,
          subtree: true
        });
      }
    }

    if (!customizeCartDrawerObserver && window.MutationObserver) {
      var cartDrawer = document.querySelector('#CartDrawer');

      if (cartDrawer) {
        customizeCartDrawerObserver = new MutationObserver(alUpdateCartDrawerState);
        customizeCartDrawerObserver.observe(cartDrawer, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    alUpdateCustomizeCROState();
    alUpdateCartDrawerState();
  }

  $(document).on('click change', '.customize-base-grid, .selected_stone, .product-single__meta .variant-wrapper input[type="radio"]', function () {
    setTimeout(alUpdateCustomizeCROState, 80);
  });

  $(document).on('click', '[data-customize-sticky-add]', function () {
    if (!alSelectedAddons().totalQty) {
      alScrollToCustomizeGrid();
      return;
    }

    $('.product-block[data-id="customize-template-grid"] .product-single__form button[data-add-to-cart]').trigger('click');
  });

  setTimeout(alInitCustomizeCRO, 100);
  setTimeout(alInitCustomizeCRO, 1200);

   if ($('.product-single__meta .variant-color').length > 0) {
    var selected_color = $('.product-single__meta .variant-color .variant-input-wrap input[type="radio"]:checked').val();
     console.log(selected_color+'ASD SAHDHAJSK');

    if (selected_color && selected_color !== 'undefined') {
      $('.customize-base-grid .customize-box').each(function () {
        var $box = $(this);
        if (!$box.hasClass('no-stone')) {
          if ($box.attr('data-addon-color') === selected_color) {
            $box.addClass('visible').removeClass('no-visible');
          } else {
            $box.addClass('no-visible').removeClass('visible');
          }
          
        }
        
      });
    }


    $('.product-single__meta .variant-wrapper .variant-input-wrap input[type="radio"]').on('change', function(){
      console.log('hello ppppp');
      var total_options = 0;
      total_options = $(this).closest('.product-block').find('.variant-wrapper').length;
      var selected_value = '';
      var selected_option1 = ''; var selected_option2 = ''; var selected_option3 = '';
      var freeaddon = $('.customize-base-grid').attr('data-freeaddon');
      
      if(total_options > 0){
        if(total_options == 1){
          var selected_value = $(this).closest('.product-block').find('.variant-wrapper .variant-input input[type="radio"]:checked').val();
        }else if(total_options == 2){
          $(this).closest('.product-block').find('.variant-wrapper').each(function(k,v){
            
            if(k == 0){
              selected_option1 = $(this).find('.variant-input input[type="radio"]:checked').val();
            }
            
            if(k == 1){
              selected_option2 = $(this).find('.variant-input input[type="radio"]:checked').val();
            }
            
          })

          selected_value = selected_option1+' / '+selected_option2;
          
        }else if(total_options == 3){
          $(this).closest('.product-block').find('.variant-wrapper').each(function(k,v){
            
            if(k == 0){
              selected_option1 = $(this).find('.variant-input input[type="radio"]:checked').val();
            }
            
            if(k == 1){
              selected_option2 = $(this).find('.variant-input input[type="radio"]:checked').val();
            }

            if(k == 2){
              selected_option3 = $(this).find('.variant-input input[type="radio"]:checked').val();
            }
            
          })

          selected_value = selected_option1+' / '+selected_option2+' / '+selected_option3;
          
        }

        if(selected_value != '' && selected_value != 'undefined' && selected_value != null){
          var price = 0;
          $('select[data-product-select] option').each(function() {
            var optionText = $(this).attr('data-vtitle');
            if (selected_value.includes(optionText)) {
              $(this).prop('selected', true);
              price = $(this).attr('data-price');
            } else {
              $(this).prop('selected', false);
            }
          });

          setTimeout(function(){
            if(price > 0){
              $('.customize-base-grid').attr('data-base-price', price);
              $('.customize-product-price-grid .customize_product_price').attr('data-base-price', price);
              alApplyCustomizePriceState();
            }
          }, 1000);
          
        }
        
      }
    })


    $('.product-single__meta .variant-color .variant-input-wrap input[type="radio"]').on('change', function(){
      var color = $(this).val();
      if(color && color !== 'undefined') {
        $('.customize-base-grid .customize-box').each(function () {
          var $box = $(this);
          if (!$box.hasClass('no-stone')) {
            if ($box.attr('data-addon-color') === color) {
              $box.addClass('visible').removeClass('no-visible');
            } else {
              $box.addClass('no-visible').removeClass('visible');
            }
          }
        });

        if ($('.customize-base-grid .selected_stone').length > 0) {
          $('.customize-base-grid .selected_stone').html('');
          var base_price = 0; var currency = '';
          base_price = $('.customize-product-price-grid .customize_product_price').attr('data-base-price');
          currency = $('.customize-product-price-grid .customize_product_price').attr('data-currency');
          if(base_price > 0){
            alApplyCustomizePriceState();
          }
        }

        /* if ($('.customize-base-grid .selected_stone').length > 0) {
          var addons_arr = [];
        
          $('.customize-base-grid .selected_stone li').each(function () {
            var id = $(this).attr('data-id');
            var addon_name = $(this).attr('class');
            
            // Check if ID already exists
            if (!addons_arr.some(obj => obj.id === id)) {
              addons_arr.push({ id: id, name: addon_name });
            }
          });

          if (addons_arr.length > 0) {
            $('.customize-base-grid .customize-box').each(function () {
              if ($(this).hasClass('visible')) {
                var stone_name = $(this).attr('data-handle');
                // Example: Check if any addon has name 'stone-type-1'
                if (addons_arr.some(obj => obj.name === stone_name)) {
                   $(this).addClass('active');
                   $(this).find('.customize-addon-label').addClass('active');
                }
        
              }else{
                var stone_name = $(this).attr('data-handle');
                // Example: Check if any addon has name 'stone-type-1'
                if (addons_arr.some(obj => obj.name === stone_name)) {
                   $(this).removeClass('active');
                   $(this).find('.customize-addon-label').removeClass('active');
                }
              }
            });

            var selected_addons_html = '';

            $('.customize-base-grid .customize-box.visible.active').each(function(){
              var val_name = $(this).find('.customize-addon-variants li input').attr('data-name');
              var val_handle = $(this).find('.customize-addon-variants li input').attr('data-handle');
              var val_price = $(this).find('.customize-addon-variants li input').attr('data-price');
              var vid = $(this).find('.customize-addon-variants li input').val();
              selected_addons_html += '<li data-qty="1" data-id="'+vid+'" data-price="'+val_price+'" class="' +
              val_handle +
              '"><span class="name">' +
              val_name +
              '</span><span class="stone_quan"><span class="minus">-</span><span class="quan_">1</span><span class="plus_">+</span></span></li>';
            })

            if(selected_addons_html != '' && selected_addons_html != 'undefined' && selected_addons_html != null){
              $(".selected_stone").html(selected_addons_html);
            }
            
          }
          
        } */
        
      }
    }) 

  }

  
  
  // Add addons 2.0 to list
  $(document).on('click', '.customize-base-grid .customize-base-inner .customize-box label.customize-addon-label', function(e){
    e.preventDefault();
    var $currentBox = $(this).closest('.customize-box');

    alRefreshAddonAvailability();

    if ($currentBox.hasClass('not-available') && !$currentBox.hasClass('no-stone')) {
      alUpdateCustomizeCROState();
      return;
    }

    var freeaddon = $('.customize-base-grid').attr('data-freeaddon');
    if(freeaddon == null || freeaddon == 'undefiend' || freeaddon == '' ){
      freeaddon = 0;
    }
    var check_stock = 0;

    if($(this).closest('.customize-box').attr('data-quantity-available') != 'undefined'){
      check_stock = $(this).closest('.customize-box').attr('data-quantity-available');
    }
    
    if(check_stock > 0){
      
      var val = ''; var price = ''; var check_if_base_selected = 0; var new_price = 0; var check_for_nostone = 0; var vid = '';
      var total = 0; var count = 0;
      var main_price = $('.customize-product-price-grid .customize_product_price').attr('data-base-price');
      $(this).addClass('active');
  
      if(!$(this).closest('.customize-box').hasClass('active')){
        $(this).closest('.customize-box').addClass('active');
      }
      
      if($(this).closest('.customize-box').hasClass('no-stone')){
        count = 0;
        var var_price = 0;
        var_price =  $('.customize_product_base').attr('data-base-price');
        
        var new_price = parseFloat(var_price).toFixed(2);
        total_price = new_price;

        $(".selected_stone").html("");
        alApplyCustomizePriceState();
      }else{
        $(".customize-box.no-stone .customize-addon-label").removeClass("active");
  
        var total = 0;
        $(".selected_stone li .quan_").each(function () {
          total = parseFloat(total) + parseFloat($(this).html());
        });
  
        var val_name = $(this).closest(' .customize-box').find('.customize-addon-variants li input').attr('data-name');
        var val_handle = $(this).closest(' .customize-box').find('.customize-addon-variants li input').attr('data-handle');
        var val_price = $(this).closest(' .customize-box').find('.customize-addon-variants li input').attr('data-price');
        var vid = $(this).closest(' .customize-box').find('.customize-addon-variants li input').val();
        var val_avl_qty = $(this).closest('.customize-box').find('.customize-addon-variants li input').attr('data-quantity-available');
  
        if ($(".selected_stone ." + val_handle).length > 0) {
          var old_qun = $(".selected_stone ." + val_handle + " .quan_").html();
          var new_quan = parseFloat(old_qun) + 1;
          $(".selected_stone ." + val_handle + " .quan_").html(new_quan);
          $(".selected_stone ." + val_handle).attr('data-qty', parseInt($(".selected_stone ." + val_handle).attr('data-qty')) + parseInt(1));
          $(".selected_stone ." + val_handle).attr('data-id', vid);
          $(".selected_stone ." + val_handle).attr('data-price', val_price);
          if (!$(".selected_stone ." + val_handle).attr('data-default-price')) {
            $(".selected_stone ." + val_handle).attr('data-default-price', val_price);
          }
          $("button#add_stone").hide();
        }else{
          $("button#add_stone").hide();
          $(".selected_stone").append(
              '<li data-qty="1" data-id="'+vid+'" data-price="'+val_price+'" data-aval-qty="'+val_avl_qty+'" class="' +
              val_handle +
              '" data-default-price="'+val_price+'"><span class="name">' +
              val_name +
              '</span><span class="stone_quan"><span class="minus">-</span><span class="quan_">1</span><span class="plus_">+</span></span></li>'
          );
        }

        alApplyCustomizePriceState(); 
        
      }
      if ($(window).width() <= 767){
        var inpuid = $(this).attr("id");
        $(".info.hide").each(function (){
            $(this).css("visibility", "hidden");
        });
        $('label[for="' + inpuid + '"] .info.hide').css(
        "visibility",
        "visible"
        );
      }
      
    }else{
      console.log('hello asdasdasd');
      if($(this).closest('.customize-box').hasClass('no-stone')){
        $(this).addClass('active');
        count = 0;
        var var_price = 0;
        var_price =  $('.customize-base-grid').attr('data-base-price');
        
        var new_price = parseFloat(var_price).toFixed(2);
        total_price = new_price;

        $(".selected_stone").html("");
        alApplyCustomizePriceState();
        
      }else{
        $("#popUpStock").show();
        setTimeout(function () {
          $("#popUpStock").hide();
        }, 1500);
      }

    }

  })


  /*********************************** For Removing Selected Stone ************************************************/
  $(document).on("click", ".selected_stone li .minus", function () {
    var $item = $(this).closest('li');
    var data_name = $item.attr('class');
    var old_val = parseInt($item.find(".quan_").html(), 10) || 1;

    if(old_val <= 1){
      $item.remove();

      $('.customize-base-grid .customize-box.visible').each(function(){
        if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
          $(this).removeClass('active');
          $(this).find('.customize-addon-label').removeClass('active');
        }
      });
    }else{
      var new_quan = old_val - 1;
      $item.find(".quan_").html(new_quan);
      $item.attr('data-qty', new_quan);
    }

    alApplyCustomizePriceState();
  });


  /*********************************** For Adding Selected Stone ************************************************/
  $(document).on("click", ".selected_stone li .plus_", function (){
    var freeaddon = $('.customize-base-grid').attr('data-freeaddon');
    if(freeaddon == null || freeaddon == 'undefiend' || freeaddon == '' ){
      freeaddon = 0;
    }
    
    var total = 0;
    var check_current_quan = '';

    var data_name = $(this).closest('li').attr('class');
    var vid = $(this).closest('li').attr('data-id');
    var available = $(this).closest('li').attr('data-aval-qty');
    var data_current_addon_price = 0;

    if(available < 1){
      available = 0;
    }
    var current_qty = $(this).closest('.stone_quan').find('.quan_').text();

    current_qty = parseInt($(this).closest('.stone_quan').find('.quan_').text()) + parseInt(1);

    if(parseInt(current_qty) > parseInt(available)){
      var msg = alThemeTemplate('alunirCustomizeLowStock', 'nur noch [count] auf Lager', { count: available });
      $('#popUpAvalQty').html(msg);
      $('#popUpAvalQty').show();
      setTimeout(function(){
        $('#popUpAvalQty').hide();
      }, 1200);
      
    }else{
      $(".selected_stone li .quan_").each(function(){
        total = parseFloat(total) + parseFloat($(this).html());
      });
     
      var old_val = $(this).parent().find(".quan_").html();
      var new_quan = parseFloat(old_val) + 1;
      $(this).closest(".stone_quan").find(".quan_").html(new_quan);
      var name = $(this).closest('li').attr('class');
  
      var check_if_qty = $(this).closest('li').attr('data-qty');
  
      total = parseFloat(total) + 1;
  
      $('.customize-base-grid .customize-box.visible').each(function(){
        if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
          data_current_addon_price = $(this).find('.customize-addon-variants li input').attr('data-price');
        }
      }) 
  
      var updated_qty = 0;
    
      if(check_if_qty != 'undefined' && check_if_qty > 0){
        updated_qty = parseInt(check_if_qty)+parseInt(1);
        $(this).closest('li').attr('data-qty',updated_qty);
        if (data_current_addon_price) {
          $(this).closest('li').attr('data-price', data_current_addon_price);
          if (!$(this).closest('li').attr('data-default-price')) {
            $(this).closest('li').attr('data-default-price', data_current_addon_price);
          }
        }
      }

      alApplyCustomizePriceState();
    }

  });


 function showCustomizeInfo(message) {
  if ($('#popUpAlert').length) {
    $('#popUpAlert').text(message).show();

    setTimeout(function () {
      $('#popUpAlert').hide().text('');
    }, 2500);
  } else {
    alert(message);
  }
}

$(document).on('click', '.product-block[data-id="customize-template-grid"] .product-single__form button[data-add-to-cart]', function(e){
  e.preventDefault();
  e.stopPropagation();

  var current_selected_variant = $('select[name="id"]').val();
  var hasAddonSelected = $('.customize-base-grid .selected_stone li').length > 0;

  if (!current_selected_variant || current_selected_variant === 'undefined') {
    showCustomizeInfo(alThemeString('alunirCustomizeChooseBase', 'Bitte w\u00E4hle zuerst deine Basis aus.'));
    return;
  }

  if (!hasAddonSelected) {
    showCustomizeInfo(alThemeString('alunirCustomizeAddPendantRequired', 'Bitte f\u00FCge mindestens einen Anh\u00E4nger hinzu.'));
    return;
  }

  var customize_addons_arr = [];
  var jsonObjp = localStorage.getItem("customize_product_data");
  var jsonObj = [];

  if (jsonObjp != '' && jsonObjp != null && jsonObjp != 'undefiend') {
    jsonObj = JSON.parse(jsonObjp);
  }

  $('.customize-base-grid .selected_stone li').each(function(){
    var product_id = $(this).attr('data-id');
    var product_qty = $(this).attr('data-qty');

    if (typeof(product_id) != 'undefined' && product_id != '') {
      customize_addons_arr.push({
        'id': product_id,
        'quantity': product_qty
      });
    }
  });

  customize_addons_arr.push({
    'id': current_selected_variant,
    'quantity': '1'
  });

  jsonObj.push({
    'product_id': current_selected_variant,
    'items': customize_addons_arr
  });

  localStorage.setItem("customize_product_two_data", JSON.stringify(jsonObj));

  let formData = {
    'items': customize_addons_arr
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(response => {
    var cart = new theme.CartDrawer;
    cart.init();
    cart.open();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
});
  
  
})
